const router = [
  {
    path: '/upload/list/:type/:parameter/:account/:tenantId',
    name: 'UploadList',
    component: () => import('@/views/upload/UploadList.vue'),
    meta: {
      title: '待上传列表',
      checkToken: true
    }
  },
  {
    path: '/accessory/upload/:type/:parameter/:account/:tenantId',
    name: 'AccessoryUpload',
    component: () => import('@/views/upload/AccessoryUpload.vue'),
    meta: {
      title: '附件上传',
      checkToken: true
    }
  },
  {
    path: '/upload/success/:type/:parameter',
    name: 'UploadSuccess',
    component: () => import('@/views/upload/UploadSuccess.vue'),
    meta: {
      title: '上传成功',
      checkToken: true
    }
  }
];
export default router;
